<template>
	<div
		v-testid="'notification-item'"
		:data-unread="isUnread"
		:class="[
			$style.notification,
			isUnread && $style['notification--unread'],
			inToast && $style['notification--toast']
		]"
	>
		<div :class="[$style['notification__dot'], isUnread && $style['notification__dot--unread']]" />
		<div :class="$style['notification__body']" @click="onBodyClick">
			<EbayTokenInvalidNotification
				v-if="type === 'EbayTokenInvalidNotification'"
				:notification="notification"
			/>
			<BulkUpdateNotification
				v-if="type === 'BulkUpdateNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'DataExportNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportInvoicesAccountingImport'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportShipmentsAccountingImport'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportSoftwareBillsAccountingImport'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportAccountingRegister'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportDebetasCompare'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataExportNotification
				v-if="type === 'ExportAttachmentsNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<DataZipExportNotification
				v-if="type === 'DataZipExportNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<BulkLabelExportNotification
				v-if="type === 'BulkLabelExportNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<PartnershipActionNotification
				v-if="type === 'PartnershipActionNotification'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<ConfirmPartPicturesUploadNotification
				v-if="type === 'ConfirmPartPicturesUploadEvent'"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
			<CreateGroupedSalePartsFromDraftNotification
				v-if="type === 'CreateGroupedSalePartsFromDraftEvent' || (type === 'ErrorEvent' && notification?.type === 'CREATE_GROUPED_SALE_PARTS_FROM_DRAFT')"
				:notification="notification"
				@success="$emit('success', $event)"
			/>
		</div>
		<div :class="$style.notification__actions">
			<NotificationLabel
				v-if="level"
				:level="level"
			/>
			<BaseIconButton
				v-if="inToast"
				v-testid="'notification-toast-close'"
				:aria-label="$t('common.actions.close')"
				:class="$style['notification__delete']"
				@click.stop="$emit('close', notification)"
			>
				<FontAwesomeIcon :icon="['fal', 'times']" />
			</BaseIconButton>
			<BaseIconButton
				v-else-if="isDeletable"
				v-testid="'notification-delete'"
				:class="$style['notification__delete']"
				@click.stop="$emit('delete', notification)"
			>
				<FontAwesomeIcon :icon="['fal', 'times']" />
			</BaseIconButton>
		</div>
	</div>
</template>

<script>
import NotificationLabel from './NotificationLabel'
import EbayTokenInvalidNotification from './types/EbayTokenInvalidNotification'
import PartnershipActionNotification from './types/PartnershipActionNotification'
import BulkUpdateNotification from './types/BulkUpdateNotification'
import DataExportNotification from './types/DataExportNotification'
import DataZipExportNotification from './types/DataZipExportNotification'
import ConfirmPartPicturesUploadNotification from './types/ConfirmPartPicturesUploadNotification'
import CreateGroupedSalePartsFromDraftNotification from './types/CreateGroupedSalePartsFromDraftNotification'
import BulkLabelExportNotification from './types/BulkLabelExportNotification'
export default {
	name: 'Notification',
	components: {
		NotificationLabel,
		EbayTokenInvalidNotification,
		PartnershipActionNotification,
		BulkUpdateNotification,
		DataExportNotification,
		DataZipExportNotification,
		ConfirmPartPicturesUploadNotification,
		CreateGroupedSalePartsFromDraftNotification,
		BulkLabelExportNotification
	},
	props: {
		notification: {
			type: Object,
			required: true
		},
		inToast: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		type () {
			return this.notification.__typename || this.notification.type
		},
		isDeletable () {
			return !['EbayTokenInvalidNotification', 'ebay_token_invalid'].includes(this.type)
		},
		isUnread () {
			return this.notification.status !== 'read'
		},
		level () {
			// TODO remove after notification gets level field
			if (this.type === 'EbayTokenInvalidNotification') {
				return 'critical'
			}
			if (this.type === 'BulkUpdateNotification') {
				return 'log'
			}
			if (this.type === 'DataExportNotification') {
				return 'log'
			}
			if (this.type === 'DataZipExportNotification') {
				return 'log'
			}
			if (this.type === 'BulkLabelExportNotification') {
				return 'log'
			}
			if (this.type === 'ExportAccountingRegister') {
				return 'log'
			}
			if (this.type === 'ExportDebetasCompare') {
				return 'log'
			}
			if (this.type === 'ExportAttachmentsNotification') {
				return 'log'
			}
			return null
		}
	},
	methods: {
		onBodyClick (event) {
			if (this.inToast && event.target.closest('a, button')) {
				this.$emit('action', this.notification)
			}
		}
	}
}
</script>

<style lang="scss" module>


	.notification {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		gap: $gutter * 1.5;
		padding: $gutter * 2;
		border-bottom: 1px solid getColor(border-light);

		&:last-child  {
			border-bottom: none;
			padding-bottom: $gutter * 2;
		}

		&--unread {
			background-color: getColor(tertiary-bg);

			:global(.notification__title) {
				font-weight: bold;
			}
		}

		&--toast {
			position: relative;
			gap: $gutter;
			padding: $gutter * 2;
			font-size: 13px;
			border-bottom: none;

			:global(.notification__title) {
				font-size: 14px;
				line-height: 1.35;
			}

			.notification__actions {
				position: absolute;
				top: $gutter * 1.5;
				right: $gutter * 2;
			}
		}

		&__dot {
			width: 8px;
			height: 8px;
			margin-top: $gutter;
			border: 2px solid getColor(primary);
			border-radius: 100%;
			flex-shrink: 0;
			background-color: transparent;

			&--unread {
				background-color: getColor(primary);
			}
		}

		&__body {
			flex: 1;
			min-width: 0;
		}

		&__actions {
			display: flex;
			align-items: center;
		}

		&__delete {
			flex-shrink: 0;
			font-size: 12px;
			color: getColor(helper-text);

			&:hover {
				color: getColor(text);
			}
		}
	}
</style>
